import { createAction } from '@reduxjs/toolkit';
import type { RecordOf } from 'immutable';
import { getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { Institution } from './institutionsTypes';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const syncInstitutionPayloadCreator = getPayloadCreator<RecordOf<QcsSyncResourcesPayload<Institution>>>();

export const getInstitution = createAction('INSTITUTION_GET_REQUEST', getPayloadCreator<{ id?: string }>());
export const getInstitutionResponse = createAction('INSTITUTION_GET_RESPONSE', syncInstitutionPayloadCreator);

export const getPopularInstitutions = createAction('INSTITUTION_GET_POPULAR_INSTITUTIONS_REQUEST', getPayloadCreator());
export const getPopularInstitutionsSuccess = createAction(
  'INSTITUTION_GET_POPULAR_INSTITUTIONS_SUCCESS',
  syncInstitutionPayloadCreator,
);
export const getPopularInstitutionsFailure = createAction(
  'INSTITUTION_GET_POPULAR_INSTITUTIONS_FAILURE',
  errorPayloadCreator,
);

export const searchForInstitutions = createAction(
  'SEARCH_FOR_INSTITUTIONS',
  getPayloadCreator<{ searchString: string }>(),
);
export const searchForInstitutionsSuccess = createAction(
  'SEARCH_FOR_INSTITUTIONS_SUCCESS',
  syncInstitutionPayloadCreator,
);
export const searchForInstitutionsFailure = createAction('SEARCH_FOR_INSTITUTIONS_FAILURE', errorPayloadCreator);
